var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfusionCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.998 4.52216H13.989V3.51587C13.989 2.96095 13.541 2.51058 12.989 2.51058H3C2.448 2.51058 2 2.96095 2 3.51587V22.4947C2 23.0496 1.552 23.5 1 23.5C0.448 23.5 0 23.0496 0 22.4947V3.51587C0 1.8501 1.343 0.5 3 0.5H12.989C14.646 0.5 15.989 1.8501 15.989 3.51587V4.52216H17C18.657 4.52216 20 5.87226 20 7.53803V16.4318C20 18.0976 18.657 19.4477 17 19.4477H15.989V22.1328C15.989 22.6877 15.541 23.1381 14.989 23.1381C14.437 23.1381 13.989 22.6877 13.989 22.1328V19.4477H12.998C11.341 19.4477 9.998 18.0976 9.998 16.4318V7.53803C9.998 5.87226 11.341 4.52216 12.998 4.52216ZM11.92 16.3906C11.92 16.9455 12.368 17.3959 12.92 17.3959H16.922C17.474 17.3959 17.922 16.9455 17.922 16.3906V7.49681C17.922 6.94189 17.474 6.49152 16.922 6.49152H12.92C12.368 6.49152 11.92 6.94189 11.92 7.49681V8.49205L13.926 8.50109C14.478 8.5031 14.924 8.95649 14.922 9.5104C14.92 10.0653 14.469 10.5137 13.918 10.5117L11.92 10.5026V12.4861L13.926 12.4951C14.478 12.4981 14.924 12.9505 14.922 13.5054C14.92 14.0603 14.469 14.5087 13.918 14.5057L11.92 14.4966V16.3906Z",
    fill: "#63C0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfusionCenter);
export default __webpack_public_path__ + "static/media/infusion-center.254f369c7489fbcd43fff237fc90b978.svg";
export { ForwardRef as ReactComponent };